const KIBANA_BASE = "https://kibana.value-marktdaten.de:457";
const KIBANA_BASE_LIVE = "https://kibana-orinoco.value-marktdaten.de:458";

const DISCOVER_PATH = "/app/discover";

type KibanaDataViewMap = Record<string, string>;

const KIBANA_DATAVIEW_IDS: Record<string, KibanaDataViewMap> = {
    LIVE: {
        "reva-stored-valuations": "1d839426-b830-4bb5-a0bd-5b58a5409b6f",
        "reva-initial-valuations": "da3127dc-226e-4161-bbfb-5e0dd43504dc",
        "reva-inspections": "9c33b8f3-9b2d-4e36-a7ac-2c3eb4ead22d",
        "usage-reva-api": "ffa925e0-7ff2-47b3-b576-5c13d7550931",
    },
    "*": {
        "reva-stored-valuations": "5adbbc4f-14a8-4f9b-a657-2d2f8517c64d",
        "reva-initial-valuations": "e80ef743-0a5d-4616-8701-b256eb3d534c",
        "reva-inspections": "f6a141e0-a73c-409c-ba9f-003932755338",
        "usage-reva-api": "7ac59a40-a811-4da5-843d-5d86f6a71ba9",
        "usage-avm-api": "7862b155-fde9-4b7f-aa66-92689136ca26",
    },
};

function getDiscoverBaseUrl(role: string): string {
    const baseUrl = role === "LIVE" ? KIBANA_BASE_LIVE : KIBANA_BASE;
    return baseUrl + DISCOVER_PATH;
}

interface KibanaLinkParams {
    /** role from environment (e.g. "LIVE", "STAGE", ...) */
    role: string;
    /** alias for the data view to display (see KIBANA_DATAVIEW_IDS for reference) */
    dataViewAlias: string;
    /** optional query to filter for */
    query?: string;
    /** time filter "from" expression (default: 15min), e.g. "now-1y%2Fd" */
    from?: string;
    /** optional sort by column (desc) */
    sortBy?: string;
}

/**
 * Link to the Discover App in Kibana.
 */
export function kibanaLink({role, dataViewAlias, query, from, sortBy}: KibanaLinkParams): string {
    const dataViewMap =
        typeof KIBANA_DATAVIEW_IDS[role] === "undefined" ? KIBANA_DATAVIEW_IDS["*"] : KIBANA_DATAVIEW_IDS[role];
    const dataViewId = dataViewMap[dataViewAlias] || KIBANA_DATAVIEW_IDS["*"][dataViewAlias];

    let link = `${getDiscoverBaseUrl(role)}#/?_g=(filters:!(),refreshInterval:(pause:!t,value:60000)`;
    if (from) {
        link += `,time:(from:${from},to:now)`;
    }
    link += ")&_a=(columns:!(),dataSource:(dataViewId:'";
    link += dataViewId;
    link += "',type:dataView),filters:!(),hideChart:!f,interval:auto,query:(language:kuery,query:";
    if (query) {
        link += `'${encodeURIComponent(query)}'`;
    }
    link += "),";
    if (sortBy) {
        link += `sort:!(!(${sortBy},desc)),`;
    }
    link += "viewMode:documents)";

    return link;
}
